import React, { FC, useMemo } from 'react'
import NoticesView from './NoticesView'
import ThemeIcon from './ThemeIcon'
import { styled } from '~/app/components'
import {
  ItemContainer,
  Title,
  Detail,
} from '~/app/components/order-list/common/OrderDetailsCommonStyled'
/**
 * DetailedInformation component
 * author: soojin.oh
 */

// type definitions
type Props = {
  id?: string
  notices?: Array<{
    title?: string | null
    contents?: string[]
  }>
  direction?: string[]
  pickup?: string[]
  themes?: Array<{
    name: string
    photo?: string
  }>
}

// styled components
const ThemesContainer = styled.div`
  width: calc(100% + 3.2rem);
`

// DetailedInformation component
const DetailedInformation: FC<Props> = function ({ id, notices, direction, pickup, themes }) {
  const themeIcons = useMemo(
    () =>
      themes?.map(
        ({ name, photo }, index) =>
          photo && <ThemeIcon src={photo} description={name} key={index} />
      ),
    [themes]
  )
  return (
    <ItemContainer id={id}>
      <Title>이용 상세 정보</Title>
      <Detail style={{ flexDirection: 'column' }}>
        <NoticesView notices={notices} />
        {(themeIcons?.length || 0) > 0 && (
          <>
            <div className={'subtitle'}>편의시설</div>
            <ThemesContainer>{themeIcons}</ThemesContainer>
          </>
        )}
      </Detail>
      <Detail style={{ flexDirection: 'column', marginBottom: '0' }}>
        <NoticesView
          notices={[
            { title: '찾아오시는길', contents: direction },
            pickup && pickup.length > 0 ? { title: '픽업안내', contents: pickup } : null,
          ]}
        />
      </Detail>
    </ItemContainer>
  )
}

export default DetailedInformation
